import React from "react";
import Menu from "../../../components/Menu";
import Chart from "chart.js/auto";
import Loading from "../../../components/Loading";
import Tabla from "./Tabla";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import Modal from "../../../components/Modal";

class Monitoreos extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      aplicaciones: [],
      aplicacionesFiltradas: [],
      cargando: true,
      searchInput: "",
      estadoInput: "",
      tiposAutenticacion: [],
      option: "aplicaciones",
      dataOriginal: [],
      modal: {
        active: false,
        message: '',
        success: false
      },
    };
  }
  componentDidMount() {
    fetch(process.env.REACT_APP_URL_DTO_BACK + "aplicacion/monitoreo", {
      method: "GET",
      headers: {
        Authorization: "Bearer " + this.props.servicio.getToken(),
        "Content-Type": "application/json",
      },
    })
      .then(async (res) => {
        if (!res.ok) {
          const errorResponse = await res.text();
          const error = JSON.parse(errorResponse);
          throw new Error(`Error ${res.status}: ${error.mensaje}`);
        }
        let responseBody = await res.json();
        await Promise.all(responseBody.mensaje.map(async (aplicacion) => {
          let monitoreo = await this.props.onObtenerEstado(aplicacion.codigo, true);
          aplicacion.estado = monitoreo.Estado;
        }));
        this.setState({ aplicaciones: responseBody.mensaje, cargando: false });
        this.dibujarGrafico();
      })
      .catch((errorP) => {
        console.error("Error en la petición:", errorP.stack || errorP);
        this.setState({ cargando: false, modal: {
          active: true,
          message: errorP.message,
          success: false
        }});
      });
  };
  contarPorEstado = () => {
    const estadosCount = {
      "Sin monitorear": 0,
      "Ok": 0,
      "Warning": 0,
      "Error": 0,
    };
  
    this.state.aplicaciones.forEach((aplicacion) => {
      let estado = aplicacion.estado;
      if (estado === "Ok") {
        estadosCount["Ok"] += 1;
      } else if (estado === "Warning") {
        estadosCount["Warning"] += 1;
      } else if (estado === "Error") {
        estadosCount["Error"] += 1;
      } else {
        estadosCount["Sin monitorear"] += 1;
      }
    });
    return estadosCount;
  };
  
  dibujarGrafico = () => {
    const estadosCount = this.contarPorEstado();
    const ctx = document.getElementById("graficoDona");
    const ShadowPlugin = {
      beforeDraw: (chart, args, options) => {
        const { ctx } = chart;
        ctx.shadowColor = "rgba(0, 0, 0, 0.16)";
        ctx.shadowBlur = 6;
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 0; 
      },
    };
    
    this.graficoDona = new Chart(ctx, {
      type: "doughnut",
      data: {
        labels: ["Ok","Error","Warning","Sin monitorear"],
        datasets: [
          {
            label: "Estado de Aplicaciones",
            data: [ estadosCount["Ok"], estadosCount["Error"], estadosCount["Warning"], estadosCount["Sin monitorear"]],
            backgroundColor: ["#0BCE63","#D6073F","#EAD409","#CED0CE"],
            borderColor: ["#0BCE63","#D6073F","#EAD409","#CED0CE"],
            borderWidth: 1,
            hoverBackgroundColor: ["#0BCE63","#D6073F","#EAD409","#CED0CE"],
            hoverBorderWidth: 2,
          },
        ],
      },
      plugins:[ShadowPlugin,ChartDataLabels],
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          tooltip:{
            enabled: false,
          },
          legend: {
            align: 'center',
            title: {
              display: true,
              text: 'Estados:',
              color: 'rgb(255, 255, 255)',
              font: 16,
              padding: 10
            },
            position: "bottom",
            labels: {
              color: 'rgb(255, 255, 255)',
              usePointStyle: true,
              pointStyle: 'circle',
            },
          },
          datalabels: { 
            align: 'center',
            color: (context) => {              
              const backgroundColor = context.chart.data.datasets[0].backgroundColor[context.dataIndex];
              return backgroundColor === '#D6073F' ? '#FFFFFF' : '#2D2E33'; 
            },         
            font: (context) => {
              const value = context.dataset.data[context.dataIndex];
              const total = context.chart.data.datasets[0].data.reduce((total, datapoint) => total + datapoint, 0);
              const percentageValue = (value / total * 100).toFixed(1);
                    const size = percentageValue > 4 ? 17 : 7; 
              return {
                  family: 'vwRegular',
                  size: size
              };
            },
            formatter: (value, context) => {
              const datapoints = context.chart.data.datasets[0].data; 
              function totalSum(total, datapoint) {
                return total + datapoint;
              }
              const totalvalue = datapoints.reduce(totalSum, 0);
              const percentageValue = (value / totalvalue * 100).toFixed(1); 
              if (percentageValue > 0) {
                return [`${Math.round(percentageValue)}%`];
              } else {
                  return [''];
              }
            }
          }
        },
      },
    });
  };
  handleChange = (event) => {
    this.setState({ searchInput: event.target.value }, () => {
      this.globalSearch();
    });
  };
  handleChangeOrg = (event) => {
    this.setState({ estadoInput: event.target.value }, () => {
      this.organizado();
    });
  };
  globalSearch = () => {
    let { aplicaciones, searchInput } = this.state;
    if (searchInput && searchInput !== "") {
      let aplicacionesFiltradas = aplicaciones.filter((value) => {
        return value.nombre.toLowerCase().includes(searchInput.toLowerCase());
      });
      this.setState({ aplicacionesFiltradas });
    } else {
      let aplicacionesFiltradas = [];
      this.setState({ aplicacionesFiltradas });
    }
  };
  organizado = () => {
    let { aplicaciones, estadoInput } = this.state;
    let objetosConEstadoDado = aplicaciones.filter(obj => obj.estado === estadoInput);
    let objetosRestantes = aplicaciones.filter(obj => obj.estado !== estadoInput);
    let aplicacionesFiltradas = objetosConEstadoDado.concat(objetosRestantes);
    this.setState({ aplicacionesFiltradas });
  };
  render() {
    return (
      <>
        <Menu />
        <Modal 
        modalInfo={this.state.modal} 
        setMostrarModal={(data) => {
          this.setState({ modal: data });
        }} 
        />
        {
          this.state.cargando && <Loading />
        }
        <div className={`navegacion`}>
          {this.state.aplicaciones?.length > 0 ? (
            <>
              <div className="row posicionMenu">
                <ul className="d-flex px-0 my-0">
                  <li className="opcion-ruta">
                    <div
                      className={`nav-link nav-link-title active ps-0 active${
                        this.state.option === "aplicaciones"
                          ? " active border_menu"
                          : ""
                      }`}
                    >
                      Dashboard
                    </div>
                  </li>
                </ul>
              </div>
              <div className="pt-4 m-0 dashboard-container d-flex">
                <div className="metrics-container">
                  <div className="apps">
                    <div className="row flex-grow-1">
                      <div className="col text-start">
                        <div className="mb-auto ps-2 title_information">
                          Apps agregadas
                        </div>
                      </div>
                      <div className="col text-end">
                        <div className="mb-auto ps-2 date_information">
                          {new Date().toLocaleDateString('en-GB').replace(/\//g, '/')}
                        </div>
                      </div>
                    </div>
                    <div className="mt-auto ps-2 num_apps border-bottom">
                      {this.state.aplicaciones.length}
                    </div>
                  </div>
                  <div className="graphics">
                    <div className="row">
                      <div className="col text-start">
                        <div className="mb-auto ps-2 title_metrics">
                          Reporte General
                        </div>
                      </div>
                      <div className="col text-end">
                        <div className="mb-auto ps-2 date_information">
                          {new Date().toLocaleDateString('en-GB').replace(/\//g, '/')}
                        </div>
                      </div>
                    </div>
                    <div className="chart-container">
                      <canvas id="graficoDona"></canvas>
                    </div>
                  </div>
                </div>
                <div className="contenedor-table monitoreo">
                  <Tabla
                    aplicaciones={
                      this.state.aplicacionesFiltradas && this.state.aplicacionesFiltradas.length
                        ? this.state.aplicacionesFiltradas
                        : this.state.aplicaciones
                    }
                    servicio={this.props.servicio}
                    marca={this.props.marca}
                    marcaNombre={this.state.marca}
                    tiposAutenticacion={this.state.tiposAutenticacion}
                    handleChange={this.handleChange}
                    handleChangeOrg={this.handleChangeOrg}
                  ></Tabla>
                </div>
              </div>
            </>
          ) : (
            <Loading />
          )}
        </div>
      </>
    );
  }
}
export default Monitoreos;